import { createAction, props } from '@ngrx/store';

export const ADD_CONFIG_ACTION = '[Config Data] add config';

export const addConfig = createAction(
  ADD_CONFIG_ACTION,
  props<{ config: any }>()
);
